

export type stepperFrom = 'basic-info' | 'additional-info';
export const steps: stepperFrom[] = ['basic-info', 'additional-info'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTabs = (tab: stepperFrom) => {
  const isLastTab = tab === 'additional-info';

  return { steps, isLastTab };
};
